var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"dir":"ltr"}},[_c('organization-chart',{attrs:{"datasource":_vm.chartData,"pan":_vm.druggable},on:{"node-click":_vm.clickedNote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }